import React, { Suspense, createContext, useContext } from 'react'
import { CartItem } from '../../../cart/storage/cart.types'
import { Product } from '../../storage'
import { QuoteModalType } from './types'
import { useSelector } from 'react-redux'
import { selectContactInfo } from '../../../azure-b2c/storage'

const QuoteModal = React.lazy(() => import('./QuoteModal'))

type QuoteModalProductType = Product | CartItem | null

export const QuoteModalContext = createContext<{
  canRequestQuote: boolean
  product: QuoteModalProductType
  quoteType: QuoteModalType
  setProduct: (item: QuoteModalProductType) => void | null
  setQuoteType: (type: QuoteModalType) => void
}>({
  canRequestQuote: false,
  product: null,
  quoteType: QuoteModalType.QUOTE,
  setProduct: () => null,
  setQuoteType: () => null,
})

export const useQuoteModal = () => useContext(QuoteModalContext)

export const QuoteProvider = (Component: () => JSX.Element) => {
  const relationshipOwner = useSelector(selectContactInfo)
  const canRequestQuote = Object.hasOwn(relationshipOwner, 'fullName')

  const [product, setProduct] = React.useState<QuoteModalProductType>(null)
  const [quoteType, setQuoteType] = React.useState<QuoteModalType>(QuoteModalType.QUOTE)

  const value = React.useMemo(() => {
    return {
      canRequestQuote,
      product,
      quoteType,
      setProduct,
      setQuoteType,
    }
  }, [canRequestQuote, product, setProduct, quoteType, setQuoteType])

  return (
    <QuoteModalContext.Provider value={value}>
      {Component()}
      {canRequestQuote || quoteType === QuoteModalType.ENQUIRY ? (
        <Suspense>
          <QuoteModal />
        </Suspense>
      ) : null}
    </QuoteModalContext.Provider>
  )
}

export default QuoteProvider
